import React from 'react';
import Icon from '../../../components/AppIcon';

const AwardsRecognition = () => {
  const awards = [
    {
      year: "2025",
      title: "Best Fast Food Restaurant",
      organization: "Juba Food Excellence Awards",
      description: "Recognized for outstanding quality, service, and community impact in the fast-food category.",
      icon: "Trophy",
      color: "primary"
    },
    {
      year: "2024",
      title: "Food Safety Excellence",
      organization: "South Sudan Food Safety Authority",
      description: "Achieved highest rating for food safety standards and hygiene practices.",
      icon: "ShieldCheck",
      color: "accent"
    },
    {
      year: "2023",
      title: "Community Champion Award",
      organization: "Juba Chamber of Commerce",
      description: "Honored for exceptional community service and local economic development contributions.",
      icon: "Heart",
      color: "secondary"
    },
    {
      year: "2022",
      title: "Innovation in Service",
      organization: "South Sudan Business Association",
      description: "First restaurant to implement WhatsApp ordering system in South Sudan.",
      icon: "Lightbulb",
      color: "primary"
    },
    {
      year: "2021",
      title: "Best New Restaurant",
      organization: "Juba Food Association",
      description: "Awarded for exceptional debut year performance and customer satisfaction.",
      icon: "Star",
      color: "secondary"
    },
    {
      year: "2021",
      title: "Customer Choice Award",
      organization: "Juba Residents Survey",
      description: "Voted favorite fast-food restaurant by local residents in annual survey.",
      icon: "Users",
      color: "accent"
    }
  ];

  const certifications = [
    {
      name: "Food Safety Certification",
      issuer: "South Sudan Food Safety Authority",
      number: "SSFSA-2024-JB-0156",
      icon: "BadgeCheck"
    },
    {
      name: "Business License",
      issuer: "Juba City Council",
      number: "JCC-BL-2020-3421",
      icon: "FileCheck"
    },
    {
      name: "Health & Hygiene Certificate",
      issuer: "Ministry of Health",
      number: "MOH-HHC-2025-0892",
      icon: "HeartPulse"
    },
    {
      name: "Halal Certification",
      issuer: "South Sudan Islamic Council",
      number: "SSIC-HC-2024-0567",
      icon: "Award"
    }
  ];

  const getColorClass = (color) => {
    const colors = {
      primary: "bg-primary/10 text-primary",
      secondary: "bg-secondary/10 text-secondary",
      accent: "bg-accent/10 text-accent"
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-secondary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Award" size={20} color="var(--color-secondary)" />
            <span className="text-secondary font-semibold text-sm md:text-base">Recognition</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Awards & Certifications
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Our commitment to excellence has been recognized by industry leaders and the community we serve
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
          {awards?.map((award, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-4 md:p-6 border border-border hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-full ${getColorClass(award?.color)} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={award?.icon} size={24} />
                </div>
                <div className="flex-1">
                  <span className="inline-block bg-muted px-3 py-1 rounded-full text-xs md:text-sm font-semibold text-foreground mb-2">
                    {award?.year}
                  </span>
                </div>
              </div>
              
              <h3 className="text-lg md:text-xl font-bold text-foreground mb-2">
                {award?.title}
              </h3>
              <p className="text-sm md:text-base text-primary font-semibold mb-3">
                {award?.organization}
              </p>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {award?.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-card rounded-xl p-6 md:p-8 border border-border">
          <h3 className="text-xl md:text-2xl font-bold text-foreground mb-6 md:mb-8 text-center">
            Official Certifications
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {certifications?.map((cert, index) => (
              <div
                key={index}
                className="bg-background p-4 md:p-6 rounded-xl border border-border flex items-start gap-4"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={cert?.icon} size={24} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-foreground text-base md:text-lg mb-1">
                    {cert?.name}
                  </h4>
                  <p className="text-sm text-muted-foreground mb-2">
                    {cert?.issuer}
                  </p>
                  <p className="text-xs md:text-sm text-primary font-mono bg-primary/5 px-3 py-1 rounded inline-block">
                    {cert?.number}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-6 md:mt-8 text-center">
            <p className="text-sm text-muted-foreground">
              All certifications are current and regularly renewed. Inspection reports available upon request.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsRecognition;